import React from 'react'
import ContactUs from '../ContactUs/ContactUs'

function ContactUsRouter(){
    return(
        <div style={{margin:'0 auto'}}>
            <ContactUs />
        </div>
    )
}
export default ContactUsRouter;